// extracted by mini-css-extract-plugin
export default {"screenshotWrapper":"cbChN","screenshot":"T_4vs","deleteScreenshotButton":"Twyg2","button":"snjaU"};